import { useState, useEffect } from "react";
import MyTable from "../../Components/MyTable";
import Mytitle from "../../Components/Mytitle";
import MyInput from "../../Components/Myinput";
import MyButton from "../../Components/MyButton";
import API from "../../Api/axiosConfig";
import { toast } from "react-toastify";

function TaxesReport() {
  const [filters, setFilters] = useState({
    from_date: "",
    to_date: "",
  });
  const [cashBalance, setCashBalance] = useState(0);
  const [appliedFilters, setAppliedFilters] = useState(null);
  const [refreshKey, setRefreshKey] = useState(0);
  const [items, setItems] = useState([]); // العملاء أو المصروفات

  const columns = [
    { header: "طريقة الدفع", accessor: "payment_type" },
    { header: "رقم الفاتورة", accessor: "invoice_number" },
    { header: "قيمة الضريبة", accessor: "tax_value" },
    { header: "قيمة الفاتورة", accessor: "total_after_tax" },
    { header: "تاريخ إنشاء الفاتورة", accessor: "date" },
  ];

  useEffect(() => {
    const today = new Date();

    // أول يوم في الشهر الحالي
    const firstDay = new Date(today.getFullYear(), today.getMonth(), 1);
    // آخر يوم في الشهر الحالي
    const lastDay = new Date(today.getFullYear(), today.getMonth() + 1, 0);

    // نحول التاريخ إلى صيغة YYYY-MM-DD بدون UTC
    const formatDate = (date) => {
      const year = date.getFullYear();
      const month = String(date.getMonth() + 1).padStart(2, "0");
      const day = String(date.getDate()).padStart(2, "0");
      return `${year}-${month}-${day}`;
    };

    setFilters({
      ...filters,
      to_date: formatDate(lastDay),
      from_date: formatDate(firstDay),
    });
  }, []);
  // console.log(filters);

  const handleSearch = () => {
    setAppliedFilters(filters);
    setRefreshKey((prev) => prev + 1);
  };
  // كشف حساب الخزنة
  return (
    <div className="container mt-5">
      <Mytitle title="تقرير الضرائب" />
      {/* 🟢 عرض الرصيد الحالي */}

      <div className="row  flex-row-reverse">
        <div className="col-md-2">
          <MyInput
            label="من"
            type="date"
            value={filters.from_date}
            onChange={(e) =>
              setFilters({ ...filters, from_date: e.target.value })
            }
            dontShowDay={true}
          />
        </div>

        <div className="col-md-2">
          <MyInput
            label="إلى"
            type="date"
            value={filters.to_date}
            onChange={(e) =>
              setFilters({ ...filters, to_date: e.target.value })
            }
            dontShowDay={true}
          />
        </div>

        <div className="col-md-1 d-flex align-items-center">
          <MyButton onClick={handleSearch} text="بحث" />
        </div>
      </div>

      {appliedFilters && (
        <MyTable
          resource="taxReport-from-to"
          method="post"
          component="taxesReport"
          title={"كشف الحسابات"}
          body={appliedFilters}
          columns={columns}
          refreshKey={refreshKey}
          cashBalance={cashBalance}
          setCashBalance={setCashBalance}
          filters={[
            {
              type: "text",
              name: "invoice_number",
              label: "بحث برقم الفاتورة",
            },
            // { type: "text", name: "customer.name", label: "بحث باسم العميل" },
          ]}
          // component="accountStatement"
        />
      )}
    </div>
  );
}

export default TaxesReport;
